// src/extenders/localization-form.js
var LocalizationForm = class extends HTMLElement {
  constructor() {
    super();
    const locationFormElement = this;
    const formElement = locationFormElement.querySelector("form");
    const allFieldsetElements = formElement.querySelectorAll("fieldset");
    const countryCodeInputElement = formElement.querySelector('input[name="country_code"]');
    const languageCodeInputElement = formElement.querySelector('input[name="language_code"]');
    this.addIconClickHandlers();
    allFieldsetElements.forEach((fielsetElement) => {
      fielsetElement.addEventListener(
        "change",
        () => {
          const selectCountryElement = formElement.querySelector('select[name="country_code"]');
          const radioCountryElement = formElement.querySelector('input[name="country_radio"]:checked');
          const selectLanguageElement = formElement.querySelector('select[name="locale_code"]');
          const radioLanguageElement = formElement.querySelector('input[name="language_radio"]:checked');
          if (countryCodeInputElement) {
            if (selectCountryElement) {
              countryCodeInputElement.value = selectCountryElement.options[selectCountryElement.selectedIndex].text;
            } else if (radioCountryElement) {
              countryCodeInputElement.value = radioCountryElement.value;
            }
          }
          if (languageCodeInputElement) {
            if (selectLanguageElement) {
              languageCodeInputElement.value = selectLanguageElement.options[selectLanguageElement.selectedIndex].text;
            } else if (radioLanguageElement) {
              languageCodeInputElement.value = radioLanguageElement.value;
            }
          }
          if (formElement)
            formElement.submit();
        },
        true,
        { passive: false }
      );
    });
  }
  addIconClickHandlers() {
    setTimeout(() => {
      const countryFieldset = this.querySelector(".country-fieldset");
      const languageFieldset = this.querySelector(".language-fieldset");
      if (countryFieldset) {
        const countryIcon = countryFieldset.querySelector("label svg");
        const countrySelect = countryFieldset.querySelector("select");
        if (countryIcon && countrySelect) {
          countryIcon.style.cursor = "pointer";
          countryIcon.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.openSelect(countrySelect);
          });
        }
      }
      if (languageFieldset) {
        const languageIcon = languageFieldset.querySelector("label svg");
        const languageSelect = languageFieldset.querySelector("select");
        if (languageIcon && languageSelect) {
          languageIcon.style.cursor = "pointer";
          languageIcon.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.openSelect(languageSelect);
          });
        }
      }
    }, 100);
  }
  openSelect(selectElement) {
    selectElement.focus();
    if (selectElement.showPicker) {
      try {
        selectElement.showPicker();
      } catch (error) {
        this.fallbackOpenSelect(selectElement);
      }
    } else {
      this.fallbackOpenSelect(selectElement);
    }
  }
  fallbackOpenSelect(selectElement) {
    const mousedownEvent = new MouseEvent("mousedown", {
      bubbles: true,
      cancelable: true,
      view: window
    });
    const clickEvent = new MouseEvent("click", {
      bubbles: true,
      cancelable: true,
      view: window
    });
    selectElement.dispatchEvent(mousedownEvent);
    selectElement.dispatchEvent(clickEvent);
    setTimeout(() => {
      selectElement.click();
    }, 50);
  }
};
if (customElements.get("localization-form") === void 0) {
  customElements.define("localization-form", LocalizationForm);
}
